import { useState } from "react";
import { Link } from "react-router-dom";
import "./CaseStudiesComponents.css";

const Field = ({ label, children, className = "" }) => {
  if (!children) return null;

  return (
    <div className={`case-study-field ${className}`.trim()}>
      <dt>{label}</dt>
      <dd>{children}</dd>
    </div>
  );
};

const CaseStudiesComponents = ({ study, imageOnRight }) => {
  const [expanded, setExpanded] = useState(false);
  const {
    id,
    title,
    subtitle,
    client,
    industry,
    challenge,
    whatWeDid = [],
    technology = [],
    result,
    testimonial,
    link,
    image,
    imageFit,
  } = study;

  const detailsId = `${id}-details`;

  return (
    <article
      id={id}
      className={`case-study-row ${imageOnRight ? "image-right" : "image-left"}`}
    >
      <div className="container">
        <div className="case-study-grid">
          <div className="case-study-copy">
            <p className="case-study-kicker">{subtitle}</p>
            <h2 className="case-study-title">
              {title}
              {subtitle ? <span className="case-study-title-divider"> — </span> : null}
              {subtitle ? <span className="case-study-title-sub">{subtitle}</span> : null}
            </h2>

            <dl className="case-study-fields">
              <div className="case-study-meta-row">
                <Field label="Client">{client}</Field>
                <Field label="Industry">{industry}</Field>
              </div>
              <Field label="Result">{result}</Field>
            </dl>

            <div
              id={detailsId}
              className={`case-study-details ${expanded ? "is-expanded" : ""}`}
              hidden={!expanded}
            >
              <dl className="case-study-fields">
                <Field label="Challenge">{challenge}</Field>
                <Field label="What Belsoft did">
                  {whatWeDid.length > 0 ? (
                    <ul className="case-study-list">
                      {whatWeDid.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  ) : null}
                </Field>
                <Field label="Technology">
                  {technology.length > 0 ? (
                    <ul className="case-study-tech">
                      {technology.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  ) : null}
                </Field>
                {testimonial?.quote ? (
                  <Field label="Client testimonial">
                    <blockquote className="case-study-quote">
                      <p>“{testimonial.quote}”</p>
                      {testimonial.attribution ? (
                        <cite>— {testimonial.attribution}</cite>
                      ) : null}
                    </blockquote>
                  </Field>
                ) : null}
              </dl>
            </div>

            <button
              type="button"
              className="case-study-read-more"
              aria-expanded={expanded}
              aria-controls={detailsId}
              onClick={() => setExpanded((open) => !open)}
            >
              {expanded ? "Read less" : "Read more"}
            </button>

            <div className="case-study-actions">
              {link ? (
                <a
                  className="case-study-btn case-study-btn-secondary"
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Live project
                </a>
              ) : null}
              <Link className="case-study-btn" to="/hire-us">
                Discuss your project
              </Link>
            </div>
          </div>

          <div className="case-study-media">
            <img
              className={`case-study-image${imageFit === "contain" ? " case-study-image-contain" : ""}`}
              src={image}
              alt={`${title} preview`}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </article>
  );
};

export default CaseStudiesComponents;
